export default "__VITE_ASSET__Cmskzr5W__"